export const colors = {
  table: {
    active: "#10B981",
    pending: "#00adff",
    disabled: "#EF4444",
  },
};
